// Public: Allows to access the internal props of the Vue component instance.
export function useListeners<T> (fn: (props: Record<string, any>) => T) {
  return fn(getCurrentInstance()?.vnode?.props || {})
}
